<template>
    <div class="mt-16 xl:mt-0">
        <div class="flex justify-between items-center">
            <h1 class="text-xl md:text-2xl font-semibold text-slate-900 dark:text-white">
                تعديل بيانات الامداد الطبي
            </h1>
        </div>

        <div class="py-2 align-middle inline-block min-w-full mt-6">
         
            <errormessage :error="errors"></errormessage>
            <form @submit.prevent="updateMedicalSupply" class="bg-white dark:bg-slate-800 text-slate-500 dark:text-slate-400 py-6 px-4  sm:p-6 shadow sm:rounded-md sm:overflow-hidden">
                <div class="grid md:grid-cols-4 gap-8">
                    <div class="input" :class="{ invalid: $v.medical_supply.name.$error }">
                        <label for="medical_supply_name" class="block text-sm font-medium ">
                            الاسم
                        </label>
                        <input
                            type="text"
                            id="medical_supply_name"
                            placeholder="أكتب الاسم."
                            v-model="medical_supply.name"
                            class="mt-1 block w-full border border-solid border-gray-300 rounded-md shadow-sm py-2 px-3 dark:text-gray-200 bg-white dark:bg-gray-600 focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm"
                            @blur="$v.medical_supply.name.$touch()"
                        />
                        <p v-if="!$v.medical_supply.name.minLength" class="text-xs text-red-500 mt-2">
                            يجب أن يحتوي الاسم على
                            {{ $v.medical_supply.name.$params.minLength.min }} أحرف على
                            الأقل.
                        </p>
                    </div>

                    <div class="input" :class="{ invalid: $v.medical_supply.address.$error }">
                        <label for="medical_supply_address" class="block text-sm font-medium ">
                            العنوان
                        </label>
                        <input
                            type="text"
                            id="medical_supply_address"
                            placeholder="أكتب العنوان."
                            v-model="medical_supply.address"
                            class="mt-1 block w-full border border-solid border-gray-300 rounded-md shadow-sm py-2 px-3 dark:text-gray-200 bg-white dark:bg-gray-600 focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm"
                            @blur="$v.medical_supply.address.$touch()"
                        />
                        <p v-if="!$v.medical_supply.address.minLength" class="text-xs text-red-500 mt-2">
                            يجب أن يحتوي الاسم على
                            {{ $v.medical_supply.address.$params.minLength.min }} أحرف على
                            الأقل.
                        </p>
                    </div>

                    <div class="input" >
                        <label for="medical_supply_longitude" class="block text-sm font-medium ">
                            خط الطول 
                        </label>
                        <input
                            type="text"
                            id="medical_supply_longitude"
                            placeholder="أكتب خط الطول ."
                            v-model="medical_supply.longitude"
                            class="mt-1 block w-full border border-solid border-gray-300 rounded-md shadow-sm py-2 px-3 dark:text-gray-200 bg-white dark:bg-gray-600 focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm"
                        />
                        
                    </div>

                    <div class="input" >
                        <label for="medical_supply_latitude" class="block text-sm font-medium ">
                            خط العرض
                        </label>
                        <input
                            type="text"
                            id="medical_supply_latitude"
                            placeholder="أكتب خط العرض."
                            v-model="medical_supply.latitude"
                            class="mt-1 block w-full border border-solid border-gray-300 rounded-md shadow-sm py-2 px-3 dark:text-gray-200 bg-white dark:bg-gray-600 focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm"
                        />
                        
                    </div>

                    <div class="input" :class="{ invalid: $v.medical_supply.storage_address.$error }">
                        <label for="medical_supply_storage_address" class="block text-sm font-medium ">
                            عنوان المخزن
                        </label>
                        <input
                            type="text"
                            id="medical_supply_storage_address"
                            placeholder="أكتب عنوان المخزن."
                            v-model="medical_supply.storage_address"
                            class="mt-1 block w-full border border-solid border-gray-300 rounded-md shadow-sm py-2 px-3 dark:text-gray-200 bg-white dark:bg-gray-600 focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm"
                            @blur="$v.medical_supply.storage_address.$touch()"
                        />
                        <p v-if="!$v.medical_supply.storage_address.minLength" class="text-xs text-red-500 mt-2">
                            يجب أن يحتوي الاسم على
                            {{ $v.medical_supply.storage_address.$params.minLength.min }} أحرف على
                            الأقل.
                        </p>
                    </div>

                    <div class="input" >
                        <label for="medical_supply_storage_longitude" class="block text-sm font-medium ">
                            خط طول المخزن
                        </label>
                        <input
                            type="text"
                            id="medical_supply_storage_longitude"
                            placeholder="أكتب خط طول المخزن."
                            v-model="medical_supply.storage_longitude"
                            class="mt-1 block w-full border border-solid border-gray-300 rounded-md shadow-sm py-2 px-3 dark:text-gray-200 bg-white dark:bg-gray-600 focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm"
                        />
                      
                    </div>

                    <div class="input" >
                        <label for="medical_supply_storage_latitude" class="block text-sm font-medium ">
                            خط عرض المخزن
                        </label>
                        <input
                            type="text"
                            id="medical_supply_storage_latitude"
                            placeholder="أكتب خط عرض المخزن."
                            v-model="medical_supply.storage_latitude"
                            class="mt-1 block w-full border border-solid border-gray-300 rounded-md shadow-sm py-2 px-3 dark:text-gray-200 bg-white dark:bg-gray-600 focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm"
                        />
                    </div>

                    <div class="input" >
                        <label for="administrator_id" class="block text-sm font-medium ">
                            اختر المسؤول 
                        </label>
                        <select
                            id="administrator_id"
                            name="administrator_id"
                            v-model="prepar_administrator_id"
                            class="mt-1 block w-full border border-solid border-gray-300 rounded-md shadow-sm py-2 px-3 dark:text-gray-200 bg-white dark:bg-gray-600 focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm"
                        >
                            <option  disabled selected>المسؤول</option>
                            <option
                                v-for="administrator in administrators_data"
                                :key="administrator.id"
                                v-bind:value="administrator.id"
                            >
                                {{ administrator.full_name }}
                            </option>

                        </select>
                    </div>
       
                </div>

                <div class="text-white w-full md:w-auto flex md:justify-end mt-8">
                    <div class="inline w-full md:w-auto" :class=" $v.$anyError ? 'cursor-not-allowed' : 'cursor-pointer' ">
                        <button
                            :disabled="$v.$anyError"
                            type="submit"
                            class="border border-transparent rounded-md shadow-sm w-full md:w-auto py-2 px-16 inline-flex justify-center text-sm font-medium focus:outline-none"
                            :class=" $v.$anyError ? 'bg-gray-600' : 'bg-indigo-600 hover:bg-indigo-700 focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500'">
                            تعديل
                        </button>
                    </div>
                </div>
            </form>
        </div>
    </div>
</template>

<script>
import errormessage from "@/components/ErrorMessage"
import { required, minLength } from "vuelidate/lib/validators";
import MedicalSuppliesService from "@/services/MedicalSuppliesService";

import AdministratorsService from "@/services/AdministratorsService";

export default {
    created() {
        this.getAdministrators();
        this.getMedicalSupply();
        
    },

    components: {
        errormessage
    },

    data() {
        return {
            errors: null,
            administrators_data:{},
            medical_supply: {
                id: this.$route.params.id,
                name : '',
                address : '',
                longitude : '',
                latitude : '',
                storage_address : '',
                storage_longitude : '',
                storage_latitude : '',
                administrator_id : '',
                role_id : '',
            },
            prepar_administrator_id : '',

        };
    },
    watch: {
        prepar_administrator_id: function() {
            
            let administrator = this.administrators_data.find(
                (element) => element.id == this.prepar_administrator_id
            );

            this.medical_supply.administrator_id = administrator.id
            this.medical_supply.role_id = administrator.role_id

        },
    },

    validations: {
        medical_supply: {
            name: {
                required,
                minLength: minLength(3),
            },
            address: {
                required,
                minLength: minLength(3),
            },
            storage_address: {
                required,
                minLength: minLength(3),
            },
            administrator_id: {
                required,
            },
        },
    },

    methods: {
        getAdministrators() {
            let loader = this.$loading.show({
                loader: this.loader,
            });

            AdministratorsService.getAdministratorsByRole(3)
                .then((res) => {
                    setTimeout(() => {
                        loader.hide();

                        this.administrators_data = res.data;

                        
                    }, 10);
                })
                .catch((err) => {
                    loader.hide();

                    this.$swal.fire({
                        icon: "error",
                        title: "...عذرا",
                        text: err.response.data.message,
                    });
                });
        },

        getMedicalSupply() {
            let loader = this.$loading.show({
                loader: this.loader,
            });

            MedicalSuppliesService.getMedicalSupply(this.$route.params.id)
                .then((res) => {
                    setTimeout(() => {
                        let data = res.data
                        this.medical_supply = data
                        this.prepar_administrator_id = data.administrator_id
                        loader.hide();
                    }, 10);
                })
                .catch((err) => {
                    loader.hide();

                    this.$swal.fire({
                        icon: "error",
                        title: "...عذرا",
                        text: err.response.data.message,
                    });
                });
        },
       
        updateMedicalSupply() {

            let loader = this.$loading.show({
                loader: this.loader,
            });

            let data = {

                medical_supplies:{
                    id: this.$route.params.id,
                    name : this.medical_supply.name,
                    address : this.medical_supply.address,
                    longitude : Number(this.medical_supply.longitude),
                    latitude : Number(this.medical_supply.latitude),
                    storage_address : this.medical_supply.storage_address,
                    storage_longitude : Number(this.medical_supply.storage_longitude),
                    storage_latitude : Number(this.medical_supply.storage_latitude),
                    
                },
                administrator:{
                    administrator_id: this.medical_supply.administrator_id,
                    role_id: this.medical_supply.role_id,
                    type: 3
                }
            }

            MedicalSuppliesService.updateMedicalSupply(data)
                .then((resp) => {

                    setTimeout(() => {
                        loader.hide();
                        this.$swal.fire({
                            icon: 'success',
                            text: resp.data.message,
                        })
                        this.$router.push({ name: "medicalsupplies" });
                    }, 10);
                
                },
                (err) => {
                    loader.hide();

                    this.errors = err.response.data.errors
                    this.$swal.fire({
                        icon: 'error',
                        title: '...عذرا',
                        text: err.response.data.message,
                    })
                }
            );
        },
    },
};
</script>

